// extracted by mini-css-extract-plugin
export var image = "TeamGridModule-module--image--6b9d9";
export var imageContainer = "TeamGridModule-module--imageContainer--2a5f5";
export var name = "TeamGridModule-module--name--abe53";
export var position = "TeamGridModule-module--position--fe28c";
export var teamMemberContainer = "TeamGridModule-module--teamMemberContainer--f80d0";
export var teamMembersContainer = "TeamGridModule-module--teamMembersContainer--ab87b";